export const environment = {
  production: false,
  API_URL: 'https://dev-api.example.com'
}; 